// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fx-W","controls":"styles_controls__1Mh6y","charLimit":"styles_charLimit__2quXZ","input":"styles_input__hz97q","send":"styles_send__2sHdK"};